 
import React, { ReactElement } from 'react';

import { SkeletonBase } from '@digital-dealer/components';

const TabletSkeleton = (): ReactElement => (
  <SkeletonBase viewBox="0 0 768 1476">
    <rect
      x="16"
      y="31"
      width="132"
      height="24"
      rx="4"
    />
    <rect
      x="16"
      y="63"
      width="651"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="91"
      width="736"
      height="456"
      rx="4"
    />
    <rect
      x="16"
      y="559"
      width="116"
      height="64"
      rx="4"
    />
    <rect
      x="140"
      y="559"
      width="116"
      height="64"
      rx="4"
    />
    <rect
      x="264"
      y="559"
      width="116"
      height="64"
      rx="4"
    />
    <rect
      x="388"
      y="559"
      width="116"
      height="64"
      rx="4"
    />
    <rect
      x="512"
      y="559"
      width="116"
      height="64"
      rx="4"
    />
    <rect
      x="636"
      y="559"
      width="116"
      height="64"
      rx="4"
    />
    <rect
      x="16"
      y="678"
      width="164.224"
      height="24"
      rx="4"
    />
    <rect
      x="16"
      y="715"
      width="736"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="744"
      width="325"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="815"
      width="164.224"
      height="24"
      rx="4"
    />
    <rect
      x="16"
      y="852"
      width="736"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="881"
      width="325"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="952"
      width="164.224"
      height="24"
      rx="4"
    />
    <rect
      x="16"
      y="989"
      width="736"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="1018"
      width="325"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="1089"
      width="164.224"
      height="24"
      rx="4"
    />
    <rect
      x="16"
      y="1126"
      width="736"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="1155"
      width="325"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="1226"
      width="164.224"
      height="24"
      rx="4"
    />
    <rect
      x="16"
      y="1263"
      width="736"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="1292"
      width="325"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="1363"
      width="164.224"
      height="24"
      rx="4"
    />
    <rect
      x="16"
      y="1400"
      width="736"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="1429"
      width="325"
      height="16"
      rx="4"
    />
  </SkeletonBase>
);

export default TabletSkeleton;
